import { memo } from "react";

function ConfettiBurst() {
    // 24 small coloured shapes radiating outward from centre. Pure CSS, no JS frame loop.
    const colors = ["#10b981", "#3b82f6", "#f59e0b", "#ec4899", "#8b5cf6", "#06b6d4"];
    const pieces = Array.from({ length: 24 }, (_, i) => {
        const angle = (i / 24) * Math.PI * 2;
        const dist = 140 + Math.random() * 80;
        return {
            id: i,
            tx: Math.cos(angle) * dist,
            ty: Math.sin(angle) * dist,
            color: colors[i % colors.length],
            delay: Math.random() * 0.15,
            shape: i % 3,
        };
    });
    return (
        <div className="absolute inset-0 pointer-events-none flex items-center justify-center" aria-hidden="true">
            {pieces.map((p) => (
                <span
                    key={p.id}
                    className="confetti absolute"
                    style={{
                        ["--tx"]: `${p.tx}px`,
                        ["--ty"]: `${p.ty}px`,
                        animationDelay: `${p.delay}s`,
                        background: p.color,
                        width: p.shape === 1 ? "6px" : "8px",
                        height: p.shape === 2 ? "12px" : "8px",
                        borderRadius: p.shape === 0 ? "9999px" : "2px",
                    }}
                />
            ))}
        </div>
    );
}

// memo: confetti has no props; once mounted it should never re-render
// (the random offsets would re-roll and re-animate, ruining the burst).
export default memo(ConfettiBurst);
